import * as angular from "angular";
import { DialogUtils } from "../../../helper/dialog.helper";

let InviteLicenseType = {
    selector: "vcInviteLicenseType",
    templateUrl:
        "/angular/components/invite/sections/invite-license-type.component.html",
    bindings: {
        type: "=",
        selectType: "&",
    },
    controller: class InviteUserTypeController {
        // * bindings for typescript compiler *
        public type: any;
        public selectType: Function;
        // ************************************

        private readonly $scope: any;
        private dialog: DialogUtils;

        constructor($scope: any, DialogUtils: DialogUtils) {
            this.$scope = $scope;
            this.dialog = DialogUtils;
        }

        openManageLicensesDialog(event: any): void {
            this.dialog.show({
                component: "license-info-dialog",
                targetEvent: event,
                size: "large",
                scope: this.$scope,
                locals: {
                    hideActions: true,
                },
            });
        }
    },
};

angular
    .module("invite")
    .component(InviteLicenseType.selector, InviteLicenseType);
